import {round} from 'lodash';
import {FC} from 'react';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';
import {toCurrency} from 'utils/number';

type PriceCalculationProps = {
    isValid: boolean;
    mailpoints: null | number;
    unitPrice: number;
};

const PriceCalculation: FC<PriceCalculationProps> = ({
    isValid,
    mailpoints,
    unitPrice,
}) => {
    const price = round((mailpoints || 0) * unitPrice);
    const priceValue = toCurrency({
        currency: 'JPY',
        value: price,
    });
    const text = isValid ? t`${priceValue} (+ Tax)` : '-';

    return (
        <div
            className={twMerge(
                'rounded rounded-b-none border border-b-0 border-grey-300',
                isValid ? 'bg-green-10' : 'bg-grey-50',
            )}
        >
            <div
                aria-label="mailpoints-total-price"
                className="p-3 text-center text-xl"
            >
                {text}
            </div>
        </div>
    );
};

export default PriceCalculation;
